import PartnerContractProductList from './PartnerContractProductList';

export default PartnerContractProductList;
